import Header from "../components/Header";
import { signInWithGoogle } from "../auth/auth";
import { useNavigate } from "react-router-dom";
import LandingImage from "../assets/landing_image.png";
import Button from "../components/Button";

export default function Landing() {
  const navigate = useNavigate();

  const handleLogin = async () => {
    await signInWithGoogle();
    navigate("/dashboard");
  };

  return (
    <>
      <Header />

      <div style={styles.container}>
        <img
          src={LandingImage}
          alt="presentation"
          style={styles.image}
        />
        <Button 
        children={"Sign in with Google"}
        onClick={handleLogin}
        variant={"solid"}
        />
      </div>
    </>
  );
}

const styles = {
  container: {
    minHeight: "calc(100dvh - 56px)", // dynamic viewport height (mobile-safe)
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 24,
    padding: "16px",
    boxSizing: "border-box",
    overflow: "hidden", // eliminate stray scrollbars
  },
  image: {
    width: "100%",
    maxWidth: 420,       // desktop cap
    height: "auto",
    objectFit: "contain",
  },
  button: {
    padding: "12px 24px",
    fontSize: 16,
    cursor: "pointer",
    width: "100%",
    maxWidth: 280,
  },
};
